<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title float-left"> Регион</h4>
                        <router-link tag="button" class="btn btn-success float-right" to="/region/new">Добавить
                        </router-link>
                    </div>
                    <div class="card-body table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th width="25%">Название</th>
                                    <th width="25%">Родитель</th>
                                    <th width="25%" class="d-none d-md-table-cell">Создано</th>
                                    <th width="25%" class="d-none d-md-table-cell">Обновлено</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                                <tr v-for="result in results.data" :key="result.id">
                                    <td>{{result.name}}</td>
                                    <td>{{result.parent ? result.parent.name : ''}}</td>
                                    <td class="d-none d-md-table-cell">
                                        <div v-if="result.createdBy">{{result.createdBy.name}}</div>
                                        <div v-if="result.createdDate">{{result.createdDate}}</div>
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <div v-if="result.updatedBy">{{result.updatedBy.name}}</div>
                                        <div v-if="result.updatedDate">{{result.updatedDate}}</div>
                                    </td>
                                    <td>
                                        <div class="btn-group btn-group-sm">
                                            <router-link :to="'/region/edit/' + result.id" tag="button" class="btn btn-info">
                                                <i class="fa fa-pencil"></i>
                                            </router-link>
                                            <button class="btn btn-danger" @click="deleteDialog(result)">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">Нет данных</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.pageCount && results.pageCount > 1 ">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page" :per-page="filter.pageSize" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import {BPagination} from 'bootstrap-vue';
    import FilterModel from './../../shared/filter';

    export default {
        name: "RegionList",
        components: {
            'b-pagination': BPagination
        },
        data() {
            return {
                loading: false,
                filter: new FilterModel(),
                results: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.get('region', this.filter.asQuery())
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page = page;
                this.initList();
            },
            deleteRegion(region) {
                this.$http.delete('region/' + region.id)
                    .then(() => {
                        this.initList();
                    }, () => {
                        this.$swal({
                            title: 'Ошибка',
                            text: 'Ошибка при удалении регион',
                            type: 'error'
                        });
                    });
            },
            deleteDialog(item) {
                this.$swal({
                    title: 'Удалить?',
                    text: 'Вы действительно хотите удалить этот регион?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Отменить',
                    confirmButtonColor: '#E5343D'
                }).then((result) => {
                    if (result.value) {
                        this.deleteRegion(item);
                    }
                });
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>